// Question keys may address a nested field with a dotted path ("contact.phone"), so
// reading and writing a value both walk the path rather than indexing the bucket
// directly. setValueAt returns a PATCH (only the touched top-level key), which is what
// the Configure onChange handlers merge into the section state.

export const getValueAt = (section, key) => {
  if (!key) return undefined
  return key.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), section)
}

export const setValueAt = (sectionState, key, value) => {
  const parts = key.split(".")
  if (parts.length === 1) return { [key]: value }
  const [head, ...rest] = parts
  const prevHead = sectionState?.[head] ?? {}
  const tailPatch = rest.reduceRight((acc, k) => ({ [k]: acc }), value)
  return { [head]: { ...prevHead, ...tailPatch } }
}
